import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { FilterPill } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import type { FiltersGroup, FiltersGroups } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import { getFilterPillFromGroupsByNames } from '@/app/common/filters/surfaces/bar/resultsPills/createBarPills.ts';
import { getSelectedValueLabelForFilters } from '@/app/common/filters/surfaces/bar/pills/filterPillLabelUtils.ts';
import { getPillIcon } from '@/app/common/filters/surfaces/bar/resultsPills/pillIcons.tsx';

export const sortLabelCreator = (filters: FiltersGroup, t: TranslationFunction): string =>
  // TODO: double check translation
  `${t('vacation.oss.components.searchresults.sort.sortby')}: ${getSelectedValueLabelForFilters(filters.filters)}`;

export const createSortPill = ({
  filtersGroups,
  t,
}: {
  filtersGroups: FiltersGroups;
  t: TranslationFunction;
}): FilterPill[] => {
  const sortPill = getFilterPillFromGroupsByNames({
    id: FILTER_NAME.SORT,
    filterNames: [FILTER_NAME.SORT],
    filtersGroups,
    label: t('vacation.oss.components.searchresults.sort.title'),
    icon: getPillIcon(FILTER_NAME.SORT),
    applyOnChange: true,
  });

  return [sortPill].filter((f) => !!f);
};
